export const appendTo = (self, container_el) => {
  self._checkNoProcessingTask();
  const canvas_el = self._getCanvasElThrowable();
  container_el.appendChild(canvas_el);
  self._container_el = container_el;
  self.fitSize();
};
